import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, Clock, ChevronRight } from "lucide-react";
import api from "../lib/api";

function badgeFor(hari) {
    if (hari >= 7) return { cls: "badge-merah", icon: "🔴", label: "Urgent" };
    if (hari >= 3) return { cls: "badge-kuning", icon: "🟡", label: "Perlu Tindak" };
    return { cls: "badge-hijau", icon: "🟢", label: "Baru" };
}

function fmtDMY(iso) {
    if (!iso) return "-";
    const p = iso.split("-");
    return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : iso;
}

export function RejectMenungguPanel() {
    const nav = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        api.get("/dashboard/reject-menunggu")
            .then((r) => setItems(r.data?.items || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return null;
    if (items.length === 0) return null;

    const urgent = items.filter((x) => x.hari_tunggu >= 7).length;
    const warn = items.filter((x) => x.hari_tunggu >= 3 && x.hari_tunggu < 7).length;

    return (
        <div className="panel border-amber-300 bg-amber-50/40 mb-6" data-testid="panel-reject-menunggu">
            <button
                onClick={() => setCollapsed((v) => !v)}
                className="w-full flex items-center justify-between p-3 border-b border-amber-200 hover:bg-amber-50"
                data-testid="toggle-reject-panel"
            >
                <div className="flex items-center gap-2">
                    <AlertTriangle className="w-4 h-4 text-amber-600" />
                    <h2 className="font-semibold text-sm text-amber-900">
                        Pengingat Reject Menunggu ({items.length})
                    </h2>
                    {urgent > 0 && (
                        <span className="badge badge-merah text-[10px]">🔴 {urgent} urgent</span>
                    )}
                    {warn > 0 && (
                        <span className="badge badge-kuning text-[10px]">🟡 {warn} perlu tindak</span>
                    )}
                </div>
                <ChevronRight className={`w-4 h-4 text-amber-700 transition-transform ${collapsed ? "" : "rotate-90"}`} />
            </button>
            {!collapsed && (
                <div className="overflow-x-auto">
                    <table className="table-nota">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Nomor Rijek</th>
                                <th>Tanggal</th>
                                <th>Vendor</th>
                                <th>Produk</th>
                                <th className="text-right">Pcs</th>
                                <th>Jenis</th>
                                <th className="text-right">Hari Tunggu</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody data-testid="reject-panel-tbody">
                            {items.map((r) => {
                                const b = badgeFor(r.hari_tunggu);
                                return (
                                    <tr
                                        key={r.id}
                                        onClick={() => nav(`/vendor/${r.vendor_id}`)}
                                        className="cursor-pointer"
                                        data-testid={`reject-row-${r.id}`}
                                    >
                                        <td>
                                            <span className={`badge ${b.cls}`}>
                                                {b.icon} {b.label}
                                            </span>
                                        </td>
                                        <td className="font-mono text-xs">{r.nomor_reject}</td>
                                        <td>{fmtDMY(r.tanggal)}</td>
                                        <td className="font-medium">{r.nama_vendor}</td>
                                        <td className="text-xs">{r.nama_produk}</td>
                                        <td className="num">{r.jumlah_pcs}</td>
                                        <td>
                                            <span className={`badge ${r.jenis === "B" ? "badge-biru" : "badge-oranye"}`}>
                                                {r.jenis === "B" ? "B: Buyback" : "A: Perbaiki"}
                                            </span>
                                        </td>
                                        <td className="num">
                                            <span className="inline-flex items-center gap-1 text-slate-700">
                                                <Clock className="w-3 h-3 text-slate-400" />
                                                {r.hari_tunggu} hari
                                            </span>
                                        </td>
                                        <td className="text-right">
                                            <span className="text-teal-600 text-xs font-medium hover:underline">Buka →</span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
